import React from 'react';
import './Playlist.css';
import TrackList from '../TrackList/TrackList';

class Playlist extends React.Component {
    constructor(props) {
        super(props);
        //this.state = {playlistTitle: ''};
        this.handleNameChange = this.handleNameChange.bind(this);
    }

    handleNameChange(e) {
        this.props.onNameChange(e.target.value);
    }

    render() {
        //console.log(this.props.playlistTracks);
        return(
            <div className="Playlist">
              <input    value={this.props.playlistName}
                        onChange={this.handleNameChange} />
                <TrackList  
                    tracks={this.props.playlistTracks}
                    onRemove={this.props.onRemove} 
                    isRemoval={true} />
                <button className="Playlist-save"
                    onClick={this.props.onSave} >{this.props.playlistId ? 'UPDATE ON SPOTIFY' : 'SAVE TO SPOTIFY'}</button>
            </div>
        )
    }
}

export default Playlist;